import service from '@/utils/server';
const modName='/toxin/toxinInspectResult/';

//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

//初始化更新对象
export const initUpdate = data => {
  return service({
    url: modName + 'details',
    method: 'post',
    data
  });
};

//检测结果录入提交
export const editData = data => {
  return service({
    url: modName + 'toxinInspectSubmit',
    method: 'post',
    data
  });
};

export const exportData = data => {
  return service({
    url: modName + 'export',
    method: 'post',
    responseType: 'blob',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/toxin/toxinInspectResult/api/index.js